<template>

    <div id="entryExam" class="bg1">

        <div class="header">
            <div class="step_info clearfix">
                <div class="fl do"><img src="../../../../public/images/touxiang.png"></div>
                <div class="fl dt">
                    <p class=""><label class="fl">姓名：</label><span>m930742868</span></p>
                    <p class=""><label class="fl">性别：</label><span>X</span></p>
                    <p class=""><label class="fl">准考证号：</label><span>11111111</span></p>
                    <p class=""><label class="fl">证件号码：</label><span>111111111111111111</span></p>
                </div>
                <div class="fl dt dth">
                    <p class=""><label class="fl">座位号：</label><span>{{ mecoSeat }}</span></p>
                    <p class=""><label class="fl">考试类型：</label><span>正常考试</span></p>
                    <p class=""><label class="fl">考试时间：</label><span>90分钟</span></p>
                    <p class=""><label class="fl">试卷加载：</label>
                        <span v-if="nums < 5">已加载</span>
                        <span v-else>加载中…</span>
                    </p>
                </div>
                <div class="fl df">
                    <div class="step_time">等待开考</div>
                    <div class="step_progress pr">
                        <el-progress color="#FB741A" text-color="#ffffff" :text-inside="true" :stroke-width="20"
                            :percentage="percentage" status="exception"></el-progress>
                    </div>
                    <div class="step_tip">正在进行加载，已经完成{{ percentage }}%</div>
                </div>
            </div>
        </div>

        <div class="step_con">
            <div class="rule_con">
                <div class="tabbars clearfix">
                    <span :class="idx == 0 ? 'fl r1 on' : 'fl r1'" @click="changeRules(0)">考场规则</span>
                    <span :class="idx == 1 ? 'fl r2 on' : 'fl r2'" @click="changeRules(1)">操作指南</span>
                </div>
                <div class="rules">
                    <div class="ifr">
                        <iframe scrolling="auto" frameborder="0" marginwidth="0" marginheight="0" :src="urls"
                            height="100%" width="100%"></iframe>
                    </div>
                </div>
            </div>
            <div class="alread_box">
                <!-- <el-button @click="myReader" type="primary" :loading="true">我已阅读</el-button> -->
                <el-button class="btns" type="info" v-if="nums != 0">我已阅读({{ nums }})</el-button>
                <el-button class="btns" @click="myReader" type="danger" v-else>我已阅读</el-button>
            </div>

        </div>


        <div class="footer"></div>
    </div>

</template>
<script>
export default {
    data() {
        return {
            meauActive: "",
            idx: 0,
            percentage: 0,
            nums: 10,
            pc: 0,
            pc_id: 0,
            mecoId: sessionStorage.getItem("access-mecoId"),
            mecoSeat: sessionStorage.getItem("access-mecoSeat"),
            mecoName: sessionStorage.getItem("access-mecoName"),
            mecoTitle: sessionStorage.getItem("access-mecoTitle"),
            urls: "//www.chinaacc.com/mnxt/jjskcgz.htm",
            code: 0,
            paper_id: 0,
        };
    },
    mounted: function () {
        var that = this;
        var query = that.$route.query;
        if (query.paper_id) {
            that.paper_id = query.paper_id;
        }
        this.getLoading();
        this.getList();
    },
    methods: {
        goHome() {
            this.$confirm('确认要退出考试吗？?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.$router.push("/web/index");
            });
        },

        countTime() {
            if (this.nums <= 10 && this.nums > 0) {
                this.nums = this.nums - 1;
                setTimeout(this.countTime, 1000);
            } else {
                this.nums = 0;
            }
        },

        getLoading() {
            if (this.percentage < 100) {
                let rand = this.percentage + Math.floor(Math.random() * 10);
                if (rand >= 100 && this.code == 1) {
                    rand = 100;
                } else if (rand >= 100 && this.code == 0) {
                    rand = 99;
                }
                this.percentage = rand;
                setTimeout(this.getLoading, 100);
            } else {
                setTimeout(this.countTime, 1000);
            }
        },

        getList() {
            let that = this;
            let formData = {};
            formData.subject_id = that.mecoId;
            formData.paper_id = that.paper_id;
            that.axios.post("/getPaperMeco", formData).then((res) => {
                if (res) {
                    that.pc = res.data.pc;
                    that.pc_id = res.data.pc_id;
                    sessionStorage.setItem("access-mecoPapers", JSON.stringify(res.data));
                    console.log(that.nums);
                    that.code = 1;
                    if (that.nums < 1) {
                        this.$router.push("/doctor/question");
                        //this.$loading.close();
                    }
                }
            });
        },

        myReader() {
            let that = this;
            console.log(that.nums);
            if (that.nums >= 2 && that.code == 1) {
                that.$message({
                    type: "error",
                    message: `操作提示:等待试卷加载完成`,
                });
                return;
            }
            console.log(this.pc);
            if (this.pc > 0) {
                this.$confirm('您已经有做题记录, 是否继续?', '提示', {
                    confirmButtonText: '继续做题',
                    cancelButtonText: '重做开始',
                    closeOnClickModal: false,
                    closeOnPressEscape: false,
                    type: 'warning'
                }).then(() => {
                    this.$router.push("/doctor/question");
                }).catch(() => {
                    that.axios.post("/clearPcQuestion", {
                        pc_id: that.pc_id
                    }).then((res) => {
                        const loading = this.$loading({
                            lock: true,
                            text: '清除中……',
                            spinner: 'el-icon-loading',
                            background: 'rgba(0, 0, 0, 0.7)'
                        });
                        that.getList();
                        setTimeout(() => {
                            loading.close();
                        }, 3000);
                    });
                });
            } else {
                this.$router.push("/doctor/question");
            }
        },

        changeRules(idx) {
            this.idx = idx;
            if (idx == 0) {
                this.urls = "//www.chinaacc.com/mnxt/jjskcgz.htm";
            } else {
                this.urls = "//www.chinaacc.com/mnxt/jjsczzn.htm";
            }
        },

        mycourse() {
            this.$router.push({
                path: "/doctor/login",
                query: {
                    paper_id: this.paper_id,
                },
            });
            //this.$router.push("/meco/login");
        },
    },
};
</script>

<style>
@import "../../../../public/css/doctor.css";

#entryExam .main {
    padding-top: 0 !important;
}

#entryExam .btns {
    width: 225px;
    height: 46px;
    line-height: 46px;
    /* background: linear-gradient(0deg, #FC7921 0%, #FDA827 100%); */
    border-radius: 5px;
    padding: 0;
    display: flex;
    justify-content: center;
    align-content: center;
    margin: 0 auto;
}
</style>